import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export function useVersionCheck() {
  const location = useLocation();
  useLayoutEffect(() => {
    if (!location.state && window.localStorage.getItem("version-update-needed-wms")) {
      window.localStorage.removeItem("version-update-needed-wms");
      window.location.reload();
      // eslint-disable-next-line no-console
      console.log("update!!");
    }
  }, [location]);
}
